module.exports = __webpack_public_path__ + "static/assets/24394afaf8d97a65f0df3005f5c46d2e.svg";